<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="pay-view">
                        <p>花费<b>{{ cost }}</b>梦三币<em class="icon i-m3b"></em>购买 {{ cost * 20 }}经验</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="buy"></div>
                        <!-- <div class="u-btn cancel" @click="closeModal"></div> -->
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{
    position: relative;
    width: 530px;
}

.pay-view{
    padding: 60px 0 60px;
    color: #8d684b;
    text-align: center;

    b{
        font-size: 28px;
    }

    em{
        color: #e44130;
    }  
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
}

.u-ctrl .u-btn.ok{
    width: 246px;
    height: 65px;
    margin: 25px auto 0;
    background-image: url(~@/assets/images/modal/btn-submit.png);     
}

</style>

<script>
import {
    apiChickenBuy,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            gid : '1',
            giftName : '经验值',
            cost : 0,
            num : 1,
            score : 0,
            text : '经验值购买',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            apiChickenBuy({
                giftId : this.gid,
                num : this.cost,
            }).then(
                res => {
                    this.destroyElement ();                
                    this.$msg_modal({text : '成功获得'+ this.cost*20 +'经验'});

                    this.$store.commit("$_setExp", this.cost*20 );
                    this.$update_task();
                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$msg_modal({text : rej.message , type : type});
                },                
            )
        }, 
        uflag_update (){
          this.$store.commit("$_setFlag", this.gid);          
        },       
    },    
}
</script>